import { useTranslation } from "react-i18next";
import { PrimaryButton } from "src/components/Default/LekUI/Button";
import { DeckModeMenu } from "src/components/NewComponents/Flashcards/App/DeckModeMenu";

interface KeepLearningButtonProps {
	deckId: number;
}

export function KeepLearningButton({ deckId }: KeepLearningButtonProps) {
	const { t } = useTranslation();

	return (
		<DeckModeMenu
			deckId={deckId}
			className="w-100"
			triggerWrapperClassName="w-100"
			menuPopperClassName="max-w-400 z-index-9999"
			renderTrigger={({ onClick, isLoading }) => (
				<PrimaryButton
					onClick={onClick}
					isLoading={isLoading}
					className="btn-size-big w-100"
					data-test-id="deck-statistics-keep-learning"
				>
					{t("modals.deckStatistics.keepLearning", "Ucz się dalej")}
				</PrimaryButton>
			)}
		/>
	);
}
